import { render, staticRenderFns } from "./CdbCustomerAddress.vue?vue&type=template&id=cf36716c&scoped=true&"
import script from "./CdbCustomerAddress.vue?vue&type=script&lang=js&"
export * from "./CdbCustomerAddress.vue?vue&type=script&lang=js&"
import style0 from "./CdbCustomerAddress.vue?vue&type=style&index=0&id=cf36716c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf36716c",
  null
  
)

export default component.exports